<ln-ln-pages-armor>
  <section body>
    <ln-hero></ln-hero>
    <div class="max-w-[1440px] mx-auto flex flex-col justify-center">
      <div class="mx-[36px] border-b-[0.5px] border-b-verde pt-[30px] sm:mx-[120px] sm:pt-[60px]"></div>
    </div>

    <div id="bodyStart" class="w-full">
      <div class="max-w-[1440px] mx-auto flex flex-col justify-center">
      <div class="mx-[36px] pb-[61px] pt-[15px] sm:mx-[120px] sm:pt-[36px]">
        <div>
          <ln-special-products-search-result [products]="products"></ln-special-products-search-result>
        </div>
        <div class="border-b-[0.5px] border-b-verde pt-[23px]"></div>
        <div class="pt-[15px]">
          <ln-artisan-designer-search-result [sellers]="sellers"></ln-artisan-designer-search-result>
        </div>
      </div>
      </div>
      <div class="border-b-[1.8px] border-t-[1.8px] border-b-beige border-t-beige bg-beige bg-opacity-40">
        <div class="max-w-[1440px] mx-auto flex flex-col justify-center">
        <ln-artisans-designers-created-products></ln-artisans-designers-created-products>
        </div>
      </div>
    </div>
  </section>
</ln-ln-pages-armor>
